import { c as _c } from "react/compiler-runtime";
import type { GridProps } from '@petsmart-ui/sparky';
import { Grid } from '@petsmart-ui/sparky';
import { trackCardUpClick } from '@libs/analytics';
import { propsImagesItems } from '../../utils/propsImagesItems';
import PromoCard from '../PromoCard';
import type { CardUpProps } from './types';
const validVariants = ['2up', 'side-by-side', '1-3up', '3up', '2-4up', '4up', '4Stack', '3-6up', '2-3-4-6up', '1-2-4up', '1-2up', 'Info'];
const isValidGridVariantGuard = (variant: string): boolean => validVariants.includes(variant);
export default function CardUpVariant(t0) {
  const $ = _c(18);
  const {
    header: title,
    cards,
    variant,
    sliceMax,
    sysId,
    pathname,
    cardHeaderTagName: t1
  } = t0;
  const cardHeaderTagName = t1 === undefined ? "h3" : t1;
  if (!isValidGridVariantGuard(variant)) {
    return null;
  }
  const t2 = variant as GridProps['variant'];
  const t3 = `card-${variant}`;
  const t4 = `card-up__card${variant}-grd`;
  let t5;
  if ($[0] !== cardHeaderTagName || $[1] !== cards || $[2] !== pathname || $[3] !== sliceMax || $[4] !== title || $[5] !== variant) {
    let t6;
    if ($[7] !== cardHeaderTagName || $[8] !== pathname || $[9] !== title || $[10] !== variant) {
      t6 = (card, index) => <Grid.Item key={card.sysId}><PromoCard description={card.description} link={variant === "Info" ? undefined : card.link} imgAlt={card.image.webAltText} imageItems={propsImagesItems(card.image)} data-test-id="promo-card" onClick={() => {
          if (variant === "Info") {
            return;
          }
          trackCardUpClick({
            variant,
            title,
            cardName: card.header || card.description,
            cardPosition: index + 1,
            link: card?.link?.webUrl,
            linkText: `${card.header}${card.description ? ` ${card.description}` : ""}`,
            pathname,
            promoType: `card-up__card${variant}-grd`
          });
        }} header={card.header} headerTagName={cardHeaderTagName} /></Grid.Item>;
      $[7] = cardHeaderTagName;
      $[8] = pathname;
      $[9] = title;
      $[10] = variant;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = cards.slice(0, sliceMax).map(t6);
    $[0] = cardHeaderTagName;
    $[1] = cards;
    $[2] = pathname;
    $[3] = sliceMax;
    $[4] = title;
    $[5] = variant;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[12] !== sysId || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <Grid variant={t2} key={sysId} data-testid={t3} className={t4}>{t5}</Grid>;
    $[12] = sysId;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}